import { NullablePermit, QuoteResponse } from 'uniswap/src/data/tradingApi/__generated__'

type QuoteWithNestedPermit = QuoteResponse['quote'] & { permitData?: NullablePermit }

/**
 * The Ring quote service currently returns Permit2 data inside `quote`, while
 * the shared Trading API schema and transaction flow expect it on the response.
 * Normalize that transport difference once at the client boundary.
 */
export function normalizeQuoteResponse<T extends QuoteResponse>(response: T): T {
  const nestedPermitData = (response.quote as QuoteWithNestedPermit).permitData

  if (response.permitData || !nestedPermitData) {
    return response
  }

  return { ...response, permitData: nestedPermitData }
}
